import { useMutation } from '../../../node_modules/@tanstack/react-query/build/modern/useMutation.js';
import { useHelpSpokeStore } from '../../../stores/index.js';
import { useApiClient } from '../../../stores/ApiClientStore.js';
import { prepareCaseRequest } from '../../../utils/Case.js';

const useCreateCase=()=>{const{ssClient}=useApiClient();const{helpCase}=useHelpSpokeStore();const createCase=async recaptchaToken=>{const url=`https://help-case-creation-service.care.vpsvc.com/v1/case/origins/helpspoke`;const response=await ssClient.post(url,prepareCaseRequest(helpCase),{headers:{"x-recap-token":recaptchaToken}});return response.data};return useMutation({mutationKey:["createCase"],mutationFn:createCase})};

export { useCreateCase };
//# sourceMappingURL=useCreateCase.js.map
